(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iitrnama-ugc-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.itrnama-ugc__play');
    if (!button) return;

    var media = button.parentElement;
    var video = document.createElement('video');
    video.className = 'itrnama-ugc__video';
    video.src = button.getAttribute('data-video');
    video.controls = true;
    video.playsInline = true;
    video.autoplay = true;

    button.remove();
    media.appendChild(video);

    var started = video.play();
    if (started && started.catch) started.catch(function () {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
